import React, { lazy, Suspense } from "react";

// An answer's figures, charts and tables (ChatVisuals), its chart library
// loaded with the first answer that has any - placeholders as tall as they
// will be until then, so the conversation does not jump.
const ChatVisuals = lazy(() => import("./ChatVisuals"));

function Loading({ visuals }) {
  return (
    <div className="mizu-viz-list" aria-hidden="true">
      {visuals.map((visual, n) => (
        <div key={visual?.id || n} className={`mizu-viz-skeleton is-${visual?.kind || "chart"}`} />
      ))}
    </div>
  );
}

export default function Visuals({ visuals, onReady }) {
  if (!Array.isArray(visuals) || !visuals.length) return null;
  return (
    <Suspense fallback={<Loading visuals={visuals} />}>
      <ChatVisuals visuals={visuals} onReady={onReady} />
    </Suspense>
  );
}
